(function fullImageViewerStateDesktop(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState.eventBus ||
    !global.NewHomeSource.FullImageViewer.UrlHandler ||
    !global.NewHomeSource.FullImageViewerSetters ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.FullImageViewerState) {
    return;
  }

  const ctaSlideId = 'CTASlide';
  let selectedImage = {};

  /**
   * @private
   * notifyResize: sends an onResize event to the event bus.
   *
   * @param {object} data with the information of the new width and height.
   */
  function notifyResize(data) {
    global.NewHomeSource.FullImageViewerState.eventBus.notifyObservers(
      'onResize',
      Object.assign(data, global.NewHomeSource.FullImageViewerState.getViewerData()[selectedImage.Collection])
    );
  }

  /**
   * @private
   * handleResie: notifies the observers about a resize event in progress.
   */
  function handleResize() {
    global.NewHomeSource.ResizeHandler.calculate(notifyResize);
  }

  /**
  * @public
  * init: inits the full image viewer state logic.
  *
  * @param {object} data to fill related to collection and images.
  */
  global.NewHomeSource.FullImageViewerState.init = function init(data) {
    if (!data || !data.Collections) {
      return;
    }

    data.Collections.forEach(global.NewHomeSource.FullImageViewerState.processCollection);
    const totalElements = global.NewHomeSource.FullImageViewerState.getAllImages().length;
    const lastImage = Object.assign({}, global.NewHomeSource.FullImageViewerState.getAllImages()[totalElements - 1]);

    if (global.NewHomeSource.FullImageViewer.Config.scheduleATour) {
      lastImage.Id = ctaSlideId;
      lastImage.Index = totalElements + 1;
      lastImage.IsCtaSlide = true;
      global.NewHomeSource.FullImageViewerState.pushCtaLastImage(lastImage);
    }
    global.NewHomeSource.FullImageViewerState.setTotalCollections(data.Collections.length);
  };

  /**
   * @public
   * setImage: sets the Full Image Viewer to the image according to the data passed.
   *
   * @param {object} trigger with the information that is going to be set.
   */
  global.NewHomeSource.FullImageViewerState.setImage = function setImage(trigger) {
    const opener = trigger.tagName ? trigger.closest('[data-full-image-viewer-opener="true"]') : trigger;
    const selectedCollectionName = selectedImage ? selectedImage.Collection : null;

    selectedImage = global.NewHomeSource.FullImageViewerSetters.getImage(
      opener,
      global.NewHomeSource.FullImageViewerState.getViewerData()
    );

    if (!selectedImage && global.NewHomeSource.FullImageViewerState.getAllImages().includes(trigger)) {
      selectedImage = trigger;
      selectedImage.IsSelected = true;
    }

    if (selectedCollectionName !== selectedImage.Collection) {
      global.NewHomeSource.FullImageViewerState.eventBus.notifyObservers('onCollectionSet', Object.assign(
        {},
        global.NewHomeSource.FullImageViewerState.getViewerData()[selectedImage.Collection]
      ));
      handleResize();
    }
    global.NewHomeSource.FullImageViewer.Config.fullImageViewer.focus();
    global.NewHomeSource.FullImageViewerState.eventBus.notifyObservers('onImageSet', Object.assign({}, selectedImage));
  };

  handleResize();
  global.addEventListener('resize', handleResize);
  global.addEventListener('orientationchange', handleResize);
}(window));
